import { css } from '@emotion/css';

export const maxDescriptionWidth = css`
  max-width: 36.8rem;
`;

export const timelineItemStyles = (isLastItem: boolean) => css`
  &.MuiTimelineItem-missingOppositeContent::before {
    content: none;
  }
  height: ${isLastItem ? 10.2 : 8.2}rem;
`;
